import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Simple tooltip component for displaying help information
 * @param {Object} props Component props
 * @param {string} props.message Message to display in the tooltip
 */
const InfoTooltip = ({ message }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <span style={{ position: 'relative', display: 'inline-block', marginLeft: 6 }}>
      <FontAwesomeIcon
        icon={faInfoCircle}
        style={{ color: '#a1a9c3', cursor: 'default', fontSize: '0.95em', verticalAlign: 'middle' }}
        role="img"
        aria-label="Info"
        onMouseOver={showTooltip}
        onFocus={showTooltip}
        onMouseOut={hideTooltip}
        onBlur={hideTooltip}
      />
      <span style={{
        visibility: isVisible ? 'visible' : 'hidden',
        position: 'absolute',
        bottom: '120%',
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#2a3342',
        color: '#fff',
        padding: '7px 12px',
        borderRadius: 6,
        fontSize: 13,
        whiteSpace: 'nowrap',
        zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
      }}>{message}</span>
    </span>
  );
};

export default InfoTooltip;
